import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepSupportingDocuments = (state) => state.get('stepSupportingDocuments');

// Helper function to safely convert Immutable object to JS
const safeToJS = (value, defaultValue) => {
  if (!value) {
    return defaultValue;
  }
  if (typeof value.toJS === 'function') {
    return value.toJS();
  }
  // If it's already a plain JS object/array, return it as is
  return value;
};

const makeSelectStepSupportingDocuments = () => createSelector(
  selectStepSupportingDocuments,
  (stepSupportingDocumentsState) => {
    // Check if stepSupportingDocumentsState exists and has getIn method
    if (!stepSupportingDocumentsState || typeof stepSupportingDocumentsState.getIn !== 'function') {
      return {
        attachDocuments: [],
        uploadPercentage: '',
        progressBarVisibility: '',
        showWarningMissingRequiredDocument: '',
        showWarningInvalidRequiredDocument: '',
        warningMissingRequiredDocument: '',
        validationMessages: [],
      };
    }

    return {
      attachDocuments: mapWithDefault(stepSupportingDocumentsState, () => {
        const attachDocuments = stepSupportingDocumentsState.getIn(['form', 'attachDocuments']);
        return safeToJS(attachDocuments, []);
      }, []),
      uploadPercentage: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'uploadPercentage']), ''),
      progressBarVisibility: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'progressBarVisibility']), ''),
      showWarningMissingRequiredDocument: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'showWarningMissingRequiredDocument']), ''),
      showWarningInvalidRequiredDocument: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'showWarningInvalidRequiredDocument']), ''),
      warningMissingRequiredDocument: mapWithDefault(stepSupportingDocumentsState, () => stepSupportingDocumentsState.getIn(['form', 'warningMissingRequiredDocument']), ''),
      validationMessages: mapWithDefault(stepSupportingDocumentsState, () => {
        const validationMessages = stepSupportingDocumentsState.getIn(['form', 'validationMessages']);
        return safeToJS(validationMessages, []);
      }, []),
    };
  }
);

const makeSelectStepSupportingDocumentsErrors = () =>
  createSelector(selectStepSupportingDocuments, (state) => {
    if (!state || typeof state.get !== 'function') {
      return [];
    }
    return state.get('errors') || [];
  });

export {
  makeSelectStepSupportingDocuments,
  makeSelectStepSupportingDocumentsErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/selectors.js